/* eslint-disable */

import request from '@/utils/request'

export function getListRoomApi(query) {
  return request({
    url: '/config-service/v1/hotel/room',
    method: 'get',
    params: query
  })
}
export function getListRoomNumApi(query) {
  return request({
    url: '/config-service/v1/hotel/room/list-by-hotel',
    method: 'get',
    params: query
  })
}
export function getAllRoomApi() {
  return request({
    url: '/config-service/v1/hotel/room/all',
    method: 'get'
  })
}

export function getRoombyID(id) {
  return request({
    url: `/config-service/v1/hotel/room/${id}`,
    method: 'get'
  })
}

export function addRoomApi(query) {
  return request({
    url: '/config-service/v1/hotel/room',
    method: 'post',
    data: query
  })
}

export function updateRoomApi(query) {
  return request({
    url: '/config-service/v1/hotel/room',
    method: 'put',
    data: query
  })
}
export function deleteRoomApi(query) {
  return request({
    url: '/config-service/v1/hotel/room',
    method: 'delete',
    data: query
  })
}
